// @ts-nocheck
import useSWRMutation from "swr/mutation";
import { endpoints } from "@/utils/common/requests/endpoints";
import { getUseSwrMutationReturn } from "@/utils/swr/getUseSwrMutationReturn";
import { swrMutator } from "@/utils/swr/mutator";

export function useCreateCrew() {
	const res = useSWRMutation(endpoints.crew.CREATE(), (url, options) => {
		options.arg.method = "post";
		return swrMutator(url, options);
	});

	return getUseSwrMutationReturn(res);
}
